<h5>RSVP</h5>

<ag-shr-change-log-detail-by-type
  [keysConfig]="rsvpKeysConfig"
  [changeLogs]="changeLogs"
></ag-shr-change-log-detail-by-type>
